import { NgHybridStateDeclaration }    from '@uirouter/angular-hybrid';

import { MyWorkshopSettingsComponent } from './my-workshop.settings.component';
import { SessionService }              from '../sessions/session.service';

export const MyWorkshopStates : Array<NgHybridStateDeclaration> = [
  {
    component: MyWorkshopSettingsComponent,
    name     : 'app.my-workshop-settings',
    url      : '/my-workshop-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) => sessionService.refresh(),
        token    : 'session'
      }
    ]
  }
];
